import { render, staticRenderFns } from "./mobile.vue?vue&type=template&id=bbf1cb7e&scoped=true"
import script from "./mobile.vue?vue&type=script&lang=js"
export * from "./mobile.vue?vue&type=script&lang=js"
import style0 from "./mobile.vue?vue&type=style&index=0&id=bbf1cb7e&prod&lang=scss&scoped=true"
import style1 from "./mobile.vue?vue&type=style&index=1&id=bbf1cb7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf1cb7e",
  null
  
)

export default component.exports